// extracted by mini-css-extract-plugin
export default {"FaqAskQuestion":"os_a bht_qt bht_a bht_w","FaqAskQuestion__outdated":"os_b bht_vr bht_xg"};